import { client } from "@/config/client"

interface CreateLpData {
  name: string
}

export function create(data: CreateLpData) {
  return client.post("/v1/learning-paths", data)
}
